import type { StorageLike } from 'pinia-plugin-persistedstate'

type HydratableStore = { $hydrate?: () => void; $persist?: () => void }

/*
 * The editor stores live in localStorage, which the server cannot read. So that the client hydrates
 * the exact markup the server rendered (one empty play, default options), the stores ignore the
 * storage while the lottery page hydrates and read it afterwards, see the plugin and useEditor.
 */
let deferred = false

export const editorStorage = (): StorageLike => {
  const storage = piniaPluginPersistedstate.localStorage()

  return {
    getItem: (key) => (deferred ? null : storage.getItem(key)),
    setItem: (key, value) => {
      if (!deferred) storage.setItem(key, value)
    },
  }
}

export const startDeferredHydration = () => {
  deferred = true
}

export const endDeferredHydration = () => {
  deferred = false
}

// the persistence plugin adds $hydrate, test setups without the plugin have nothing to read
export const hydrateEditorStores = (...stores: HydratableStore[]) => {
  endDeferredHydration()
  stores.forEach((store) => store.$hydrate?.())
}

/*
 * Pinia skips its subscribers for mutations made in the same tick as a $patch, which $hydrate is.
 * Everything the editor changes right after hydrating would otherwise never reach the storage.
 */
export const persistEditorStores = (...stores: HydratableStore[]) => {
  stores.forEach((store) => store.$persist?.())
}
